import React from "react";

// Partially reverse engineered https://aff.bstatic.com/static/affiliate_base/js/flexiproduct.js
// Builds the iframe directly in React, rather than pulling in external JS and building async
// This prevents the content-shift & fixes the hot-reload interaction with external JS.

export default function BookingDotComInsert({ children, ...rest }) {
  // Strip the "data-" prefix from all the keys in props
  var props = Object.assign(
    ...Object.keys(rest).map((i) => {
      return { [i.replace("data-", "")]: rest[i] };
    })
  );

  // Use dict from CDN JS to convert input props to iframe props
  var translated = {
    product: props.prod?.toLowerCase(),
    w: props.width,
    h: props.height,
    cc1: props.cc1,
    lang: "ualng" === props.lang ? "en-US" : props.lang,
    aid: props.aid,
    label: props.label_load,
    label_click: props.label_out,
    target_aid: props.target_aid,
    selected_currency: props.currency,
    ss: props.ss,
    ss_id: props.dest_id,
    ss_type: props.dest_type,
    df_checkin: props.df_checkin,
    df_duration: props.df_duration,
    checkin: props.checkin,
    checkout: props.checkout,
    banner_id: props.banner_id,
    tmpl: props.tmpl,
    aff_hostname: props.aff_hostname,
    hid: props.hid,
    show_rw_badge: props.show_rw_badge,
    show_rw_logo: props.show_rw_logo,
    show_rw_text: props.show_rw_text,
    show_rw_border: props.show_rw_border,
    right_align_rw: props.right_align_rw,
    df_num_properties: props.df_num_properties,
    fid: +new Date(),
    latitude: props.latitude,
    longitude: props.longitude,
    landmark_name: props.landmark_name,
    mwhsb: props.mwhsb,
    iata: props.iata,
    postal_code: props.postal_code,
    zoom: props.zoom,
    address: props.address,
  };

  // Build the query string for iframe
  var srcQuery = Object.keys(translated)
    .filter((i) => translated[i])
    .map((i) => `${i}=${encodeURIComponent(translated[i])}`)
    .join("&amp;");

  return (
    <iframe
      title="Booking.com Map Widget"
      src={`//www.booking.com/flexiproduct.html?${srcQuery}`}
      width={translated.w}
      height={translated.h}
      scrolling="no"
      style={{
        order: "none",
        padding: 0,
        margin: 0,
        overflow: "hidden",
        width: translated.w,
        height: translated.h,
      }}
      marginheight="0"
      marginwidth="0"
      frameborder="0"
      allowtransparency="true"
      Booking
      id={`booking_widget__${translated.aid}__${translated.fid}`}
      data-responsive="true"
    >
      {children}
    </iframe>
  );
}
